import { render, staticRenderFns } from "./CampusAgregar.vue?vue&type=template&id=901eb184"
import script from "./CampusAgregar.vue?vue&type=script&lang=js"
export * from "./CampusAgregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports